export const fadeIn = (direction, delay) => {
  return {
    hidden: {
      y: direction === 'up' ? 80 : direction === 'down' ? -80 : 0,
      opacity: 0,
      x: direction === 'left' ? 80 : direction === 'right' ? -80 : 0,
    },
    show: {
      y: 0,
      x: 0,
      opacity: 1,
      transition: {
        type: 'tween',
        duration: 1.2,
        delay: delay,
        ease: [0.25, 0.25, 0.25, 0.75],
      },
    },
  };
};



export const fadeInSkills = (direction, delay) => {
  return {
    hidden: {
      y: direction === 'up' ? 10 : direction === 'down' ? -10 : 0,
      opacity: 0,
      x: direction === 'left' ? 10 : direction === 'right' ? -10 : 0,
    },
    show: {
      y: 0,
      x: 0,
      opacity: 1,
      transition: {
        type: 'tween',
        duration: 1.2,
        delay: delay,
        ease: [0.25, 0.25, 0.25, 0.75],
      },
    },
  };
};

export const sidebarVariants = {
  open: (height = 1000) => ({
    clipPath: `circle(${height * 2 + 200}px at calc(100% - 40px) 40px)`,
    transition: {
      type: "spring",
      stiffness: 20,
      restDelta: 2
    }
  }),
  closed: {
    clipPath: "circle(30px at calc(100% - 40px) 40px)",
    transition: {
      delay: 0.2,
      type: "spring",
      stiffness: 400,
      damping: 40
    }
  }
};

export const iconVariants = {
  open: {
    rotate: 180,
    opacity: 1,
    transition: { duration: 0.3 },
  },
  closed: {
    rotate: 0,
    opacity: 1,
    transition: { duration: 0.3 },
  },
};

export const textVariants = {
  open: {
    opacity: 0,
    y: -10,
    transition: { duration: 0.3 },
  },
  closed: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.3 },
  },
};
